var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.rating_arena", [amt_admin]);
var season_table = require("./_season/table");

app.directive('ratingArenaSeasonTable', season_table);

app.service('rating_arena_api', ['jsonrpc', function(jsonrpc) {
  const service = jsonrpc.newService('rating_arena');
  this.power_gain_table = service.createMethod('power_gain_table');
  this.spent_usd_table = service.createMethod('spent_usd_table');
}]);

app.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('amt.ww2.rating_arena', {
      url: "/rating_arena",
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: "Rating Arena",
        role: "rating_arena"
      },
      menu: {
        glyphicon: 'text-background',
        childs: [
          {state: 'amt.ww2.rating_arena.activity', glyphicon: 'text-background'},
          {state: 'amt.ww2.rating_arena.power_gain', glyphicon: 'text-background'},
          {state: 'amt.ww2.rating_arena.spent_usd', glyphicon: 'text-background'},
        ],
      },
    })
    .state('amt.ww2.rating_arena.activity', require('./activity').default)
    .state('amt.ww2.rating_arena.power_gain', require('./power_gain').default)
    .state('amt.ww2.rating_arena.spent_usd', require('./spent_usd').default)
}]);

export default app.name;
